export const types = {
    CREDIT_BILLS_REQUEST: "creditBills/CREDIT_BILLS_REQUEST",
    CREDIT_BILLS_SUCCESS: "creditBills/CREDIT_BILLS_SUCCESS",
    CREDIT_BILLS_FAILURE: "creditBills/CREDIT_BILLS_FAILURE",

    CREDIT_BILLS_DETAIL_REQUEST: "creditBills/CREDIT_BILLS_DETAIL_REQUEST",
    CREDIT_BILLS_DETAIL_SUCCESS: "creditBills/CREDIT_BILLS_DETAIL_SUCCESS",
    CREDIT_BILLS_DETAIL_FAILURE: "creditBills/CREDIT_BILLS_DETAIL_FAILURE",

    SET_CREDIT_BILLS_FILTERS: "creditBills/SET_CREDIT_BILLS_FILTERS",

    SET_CREDIT_BILLS_VALUES: "creditBills/SET_CREDIT_BILLS_VALUES",

    CREDIT_BILLS_CONFIRM_REQUEST: "afip/CREDIT_BILLS_CONFIRM_REQUEST",
    CREDIT_BILLS_CONFIRM_FAILURE: "afip/CREDIT_BILLS_CONFIRM_FAILURE",
    CREDIT_BILLS_CONFIRM_SUCCESS: "afip/CREDIT_BILLS_CONFIRM_SUCCESS",

    SET_BILLS_TODO_ACTION: "creditBills/SET_BILLS_TODO_ACTION",
    CLEAN_ACTION_TICKET: "creditBills/CLEAN_ACTION_TICKET",
    SET_BILL_LIST: "creditBills/SET_BILL_LIST",

    ACTION_BILL_REQUEST: "creditBills/ACTION_BILL_REQUEST",
    ACTION_BILL_SUCCESS: "creditBills/ACTION_BILL_SUCCESS",
    ACTION_BILL_FAILURE: "creditBills/ACTION_BILL_FAILURE",

    CREDIT_BENEFICIARY_REQUEST: "creditBills/CREDIT_BENEFICIARY_REQUEST",
    CREDIT_BENEFICIARY_SUCCESS: "creditBills/CREDIT_BENEFICIARY_SUCCESS",
    CREDIT_BENEFICIARY_FAILURE: "creditBills/CREDIT_BENEFICIARY_FAILURE",

    SET_CHECKED_BILLS: "creditBills/SET_CHECKED_BILLS",
};

export const INITIAL_STATE = {
    creditBillList: [],
    checkedBills: [],
    filters: {
        pageNumber: 1,
        rowsPerPage: 20,
        orderBy: "facturas.fecha_emision",
    },
    fetching: false,
    errorMessage: "",
    totalPages: 0,
    totalFacturas: 0,
    creditBillsPrestacion: {},
    creditBillsConfirm: {},
    actionData: {},
    actionTicket: { status: "", idTransaction: "" },
    beneficiaries: { imf: [], pnfc: [] },
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        creditBillList,
        filters,
        errorMessage,
        creditBillsDetailList,
        pageNumber,
        rowsPerPage,
        totalPages,
        totalFacturas,
        creditBillsConfirm,
        actionData,
        actionTicket,
        message,
        billToRemove,
        beneficiaries,
    } = action;

    switch (action.type) {
        case types.CREDIT_BILLS_REQUEST:
            return {
                ...state,
                filters,
                fetching: true,
            };
        case types.CREDIT_BILLS_SUCCESS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    pageNumber,
                    rowsPerPage,
                },
                creditBillList: [...state.creditBillList, ...creditBillList],
                totalPages,
                totalFacturas,
                fetching: false,
            };
        case types.CREDIT_BILLS_FAILURE:
            return {
                ...INITIAL_STATE,
                errorMessage,
                fetching: false,
            };

        case types.CREDIT_BILLS_DETAIL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.CREDIT_BILLS_DETAIL_SUCCESS:
            return {
                ...state,
                creditBillsDetailList,
                fetching: false,
            };
        case types.CREDIT_BILLS_DETAIL_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_CREDIT_BILLS_FILTERS:
            return {
                ...state,
                filters,
                creditBillList: [],
                checkedBills: state.filters.billTab === filters.billTab ? state.checkedBills : [],
            };
        case types.CREDIT_BILLS_CONFIRM_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.CREDIT_BILLS_CONFIRM_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.CREDIT_BILLS_CONFIRM_SUCCESS:
            return {
                ...state,
                fetching: false,
                creditBillsConfirm,
            };
        case types.SET_BILLS_TODO_ACTION:
            return {
                ...state,
                actionData,
            };
        case types.ACTION_BILL_SUCCESS:
            return {
                ...INITIAL_STATE,
                actionTicket,
                fetching: false,
            };
        case types.ACTION_BILL_FAILURE:
            return {
                ...state,
                message,
                fetching: false,
            };
        case types.CLEAN_ACTION_TICKET:
            return {
                ...state,
                actionTicket: { status: "", idTransaction: "" },
            };
        case types.SET_BILL_LIST:
            return {
                ...state,
                actionData: {
                    ...state.actionData,
                    invoiceList: state.actionData.invoiceList.filter(
                        (item) => item.facturaId.numeroComprobante !== billToRemove,
                    ),
                },
            };
        case types.CREDIT_BENEFICIARY_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.CREDIT_BENEFICIARY_SUCCESS:
            return {
                ...state,
                beneficiaries,
                fetching: false,
            };
        case types.CREDIT_BENEFICIARY_FAILURE:
            return {
                ...state,
                errorMessage,
                fetching: false,
            };
        case types.SET_CHECKED_BILLS:
            return {
                ...state,
                checkedBills: action.checkedBills,
            };

        default:
            return state;
    }
};

export const actions = {
    getCreditBills: (filters) => ({
        type: types.CREDIT_BILLS_REQUEST,
        filters,
    }),
    getCreditBillsDetail: (cuitEmisor, tipoComprobante, numeroComprobante, puntoVenta) => ({
        type: types.CREDIT_BILLS_DETAIL_REQUEST,
        cuitEmisor,
        tipoComprobante,
        numeroComprobante,
        puntoVenta,
    }),
    setCreditBillFilters: (filters) => ({
        type: types.SET_CREDIT_BILLS_FILTERS,
        filters,
    }),
    confirmCreditBillsReducer: (creditBillsConfirm, formikBag, credentialType) => ({
        type: types.CREDIT_BILLS_CONFIRM_REQUEST,
        creditBillsConfirm,
        formikBag,
        credentialType,
    }),
    setActionData: (actionData) => ({
        type: types.SET_BILLS_TODO_ACTION,
        actionData,
    }),
    transmitBill: (actionData, formikBag, credentialType) => ({
        type: types.ACTION_BILL_REQUEST,
        actionData,
        formikBag,
        credentialType,
    }),
    cleanServiceTicket: () => ({
        type: types.CLEAN_ACTION_TICKET,
    }),
    setBillList: (billToRemove) => ({
        type: types.SET_BILL_LIST,
        billToRemove,
    }),
    getBeneficiaries: (transmissionType) => ({
        type: types.CREDIT_BENEFICIARY_REQUEST,
        transmissionType,
    }),
    setChechedBills: (checkedBills) => ({
        type: types.SET_CHECKED_BILLS,
        checkedBills,
    }),
};
